import { fetchEndpoint } from "../network";

/**
 * 内容管理 - 晨视频报管理
 */

export default {
  // 列表
  list(params) {
    return fetchEndpoint("/create-platform/circle/list", "GET", params);
  },
  // 创建
  create(params) {
    return fetchEndpoint("/create-platform/circle/create", "POST", params);
  },
  // 更改状态
  status(params) {
    return fetchEndpoint("/create-platform/circle/status", "POST", params);
  },
  // 批量更改状态
  statusBatch(params) {
    return fetchEndpoint("/create-platform/circle/stateBatch", "POST", params);
  },
  // 批量删除
  deleteBatch(params) {
    return fetchEndpoint("/create-platform/circle/deleteBatch", "POST", params);
  },
  // 变更推荐状态
  recommendStatus(params) {
    return fetchEndpoint(
      "/create-platform/circle/recommendStatus",
      "POST",
      params
    );
  },
  // 圈子关联页面
  addRelation(params) {
    return fetchEndpoint("/create-platform/circle/addRelation", "POST", params);
  },
  // 圈子取消关联页面
  removeRelation(params) {
    return fetchEndpoint(
      "/create-platform/circle/removeRelation",
      "POST",
      params
    );
  },

  // 变更推荐排序
  recommendSort(params) {
    return fetchEndpoint(
      "/create-platform/circle/recommendSort",
      "POST",
      params
    );
  },
  // 详情
  detail(id) {
    return fetchEndpoint("/create-platform/circle/detail/?id=" + id, "GET");
  },

  // 修改
  update(params) {
    return fetchEndpoint("/create-platform/circle/modify", "POST", params);
  },

  // 批量审核圈子
  examineBatch(params) {
    return fetchEndpoint(
      "/create-platform/circle/examineBatch",
      "POST",
      params
    );
  },

  // 获取置顶内容列表
  topList(params) {
    return fetchEndpoint("/create-platform/circle/content/top", "get", params);
  },

  contentList(params) {
    return fetchEndpoint(
      "/create-platform/circle/content/unTop",
      "get",
      params
    );
  },
  // 更改内容显示状态
  contentStatus(params) {
    return fetchEndpoint(
      "/create-platform/circle/content/state",
      "post",
      params
    );
  },
  showBatch(params) {
    return fetchEndpoint(
      "/create-platform/circle/content/showBatch",
      "post",
      params
    );
  },
  // 更改内容置顶状态
  topStatus(params) {
    return fetchEndpoint(
      "/create-platform/circle/content/topState",
      "post",
      params
    );
  },

  // 更改内容置顶排序
  topSort(params) {
    return fetchEndpoint(
      "/create-platform/circle/content/top/sorting",
      "post",
      params
    );
  },

  // 删除
  delete(params) {
    return fetchEndpoint("/create-platform/circle/delete", "POST", params);
  },
  // 提交审核
  examine(params) {
    return fetchEndpoint("/create-platform/circle/examine", "POST", params);
  },
  //批量添加置顶
  addTop(params) {
    return fetchEndpoint(
      "/create-platform/circle/content/addTop",
      "POST",
      params
    );
  },
  //批量移除置顶
  removeTop(params) {
    return fetchEndpoint(
      "/create-platform/circle/content/removeTop",
      "POST",
      params
    );
  },
  //获取内容详情
  commentDetail(params) {
    return fetchEndpoint("/create-platform/comment/detail", "get", params);
  },
  //删除内容
  commentDelete(params) {
    return fetchEndpoint(
      "/create-platform/comment/removeComments",
      "post",
      params
    );
  },
  commentUpdate(params) {
    return fetchEndpoint("/create-platform/comment/modify", "post", params);
  },
  commentUpdateBatch(params) {
    return fetchEndpoint(
      "/create-platform/comment/modifyBatch",
      "post",
      params
    );
  },
};
